import { type RequestPayload, router } from "@inertiajs/core";
import { ProbationConfigForm } from "../../../components/reportConfig/form/ProbationConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Group } from "../../../models/group";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type ProbationConfigCreateProps = {
  year_contexts: YearContext[];
  groups: Group[];
};

export default function PorbationConfigCreate({ year_contexts, groups }: ProbationConfigCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);
  return (
    <ContentShell title="Neue Probezeibericht-Vorlage" onBack={() => router.get(pathWithYearContext(report_configurations_path))}>
      <ProbationConfigForm saveButtonLabel="Erstellen" groups={groups} yearContexts={year_contexts} onSubmit={onSubmit} />
    </ContentShell>
  );
}
